<template>
  <main v-if="loaded" v-show="isAccess">
    <Header />
    <section class="mypage">
      <div class="container">
        <div class="row clearfix">
          <div class="breadcrumb">
            <h2 v-text="$t('profile.personal_setting')"></h2>
          </div>
        </div>

        <div class="row clearfix">
          <div
            class="
              offset-xxl-0
              col-xxl-4
              offset-xl-0
              col-xl-4
              offset-lg-3
              col-lg-6 col-md-12 col-sm-12
            "
          >
            <div class="card profile">
              <div class="header" v-text="$t('common.profile')"></div>
              <div class="body">
                <div class="info">
                  <div class="image">
                    <div class="image-box">
                      <img :src="profilePhoto" alt="Profile Image" />
                    </div>
                    <button
                      class="icon delete"
                      @click="clickDeletePhotoFile"
                    ></button>
                    <button class="icon change" @click="clickPhotoFile">
                      <input
                        type="file"
                        ref="profile"
                        @change="changeProfile"
                        name
                        style="display: none"
                      />
                    </button>
                  </div>
                  <div class="spec">
                    <div class="form-box">
                      <label v-text="$t('common.t_name')"></label>
                      <p v-text="fetchedUserProfile.user_name"></p>
                    </div>
                    <div class="form-box">
                      <label v-text="$t('common.t_id_email')"></label>
                      <p v-text="fetchedUserProfile.email"></p>
                    </div>
                    <div class="form-box">
                      <label v-text="$t('phone')"></label>
                      <input
                        type="number"
                        :value="userTelno"
                        @input="telno"
                        @placeholder="$t('phone')"
                      />
                    </div>
                  </div>
                </div>
                <div class="password">
                  <div class="form-box">
                    <label v-text="$t('common.t_pw_curr')"></label>
                    <input
                      v-model="pw"
                      type="password"
                      @input="changeCheckPW"
                      :placeholder="$t('common.t_pw')"
                    />
                  </div>
                  <div class="form-box">
                    <label v-text="$t('common.t_pw_change_input')"></label>
                    <input
                      v-model="pw_change"
                      ref="password_change"
                      type="password"
                      :placeholder="$t('common.t_pw_change_input')"
                      :disabled="isDisableChangePW"
                    />
                  </div>
                  <div class="form-box">
                    <label v-text="$t('common.t_pw_confirm')"></label>
                    <input
                      v-model="pw_confirm"
                      type="password"
                      :placeholder="$t('common.t_pw_confirm')"
                      :disabled="isDisableChangePW"
                    />
                  </div>
                </div>
              </div>
              <div class="footer">
                <button
                  class="button primary"
                  @click="editUserProfile"
                  v-text="$t('save_change')"
                ></button>
              </div>
            </div>
          </div>

          <div
            class="
              offset-xxl-0
              col-xxl-4
              offset-xl-0
              col-xl-4
              offset-lg-3
              col-lg-6 col-md-12 col-sm-12
            "
          >
            <div class="card screen">
              <div class="header" v-text="$t('sign')"></div>
              <div class="body">
                <div class="info">
                  <div class="form-box">
                    <label v-text="$t('enrolled_sign')"></label>
                    <p
                      v-text="
                        `${fetchedDeviceTotalCnt} ${$t('common.t_sign_unit')}`
                      "
                    ></p>
                  </div>
                </div>
              </div>
              <div class="footer">
                <button
                  class="button primary"
                  @click.prevent="onGuidePopup"
                  v-text="$t('device_setting.device_add_guide')"
                ></button>
              </div>
            </div>
          </div>
          <div
            v-if="isShowFranchInfo"
            class="
              offset-xxl-0
              col-xxl-4
              offset-xl-0
              col-xl-4
              offset-lg-3
              col-lg-6 col-md-12 col-sm-12
            "
          >
            <div class="card franchise">
              <div class="header" v-text="$t('common.t_franchise')"></div>
              <div class="body">
                <div
                  v-if="fetchedUserProfile.franchise_id !== null"
                  class="info"
                >
                  <div class="image">
                    <div class="image-box">
                      <img :src="franchiseProfilePhoto" alt="Profile Image" />
                    </div>
                  </div>
                  <div class="spec">
                    <div class="form-box">
                      <label v-text="$t('common.t_name_franchise')"></label>
                      <p v-text="fetchedUserProfile.franchise_name"></p>
                    </div>
                    <div class="form-box">
                      <label v-text="$t('common.t_s_code')"></label>
                      <p v-text="fetchedUserProfile.franchise_id"></p>
                    </div>
                    <div class="form-box">
                      <label v-text="$t('user.t_reg_date')"></label>
                      <p
                        v-text="
                          this.makeDateForm(
                            fetchedUserProfile.franchise_register_datetime,
                          )
                        "
                      ></p>
                    </div>
                  </div>
                </div>
                <div class="search">
                  <p class="description">
                    {{
                      $t('common.join_fran_req_desc', {
                        status: fetchedUserProfile.franchise_id !== null
                          ? $t('common.fran_change')
                          : $t('common.fran_join')}),
                    }}
                  </p>
                  <div class="search-box">
                    <input
                      @input="searchFCName"
                      type="text"
                      :placeholder="$t('franchise_name')"
                    />
                  </div>
                  <div
                    v-if="fcNameResult && fcNameResult.length > 0"
                    :class="[
                      'result-box',
                      {
                        'req-join': fetchedUserProfile.franchise_id === null,
                        joined: fetchedUserProfile.franchise_id !== null,
                      },
                    ]"
                  >
                    <ul>
                      <li v-for="(item, index) in fcNameResult" :key="index">
                        <div class="checkbox">
                          <label>
                            <input
                              v-model="searched_fc_id"
                              name="searched_fc_id"
                              type="radio"
                              @click="toggleButton"
                              :value="item.id"
                            />
                            <span>
                              {{ $t('common.t_name_franchise') }} -
                              {{ item.name }}
                              <span
                                v-text="`${$t('common.t_s_code')} - ${item.id}`"
                              ></span>
                            </span>
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="false" class="footer">
                <button
                  class="button primary"
                  v-text="$t('common.fran_change')"
                ></button>
              </div>
              <div v-else class="footer">
                <button
                  @click="requestJoinFC"
                  class="button primary"
                  v-text="$t('common.d_ack')"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupGuide :opened="isGuidePopupOpened" @popupOff="onGuidePopup" />
    </section>
    <Footer />
  </main>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { exceptHandler } from '@action/util';
import videoData from '@api/video';
import { ERR } from '@config/common';
import PopupGuide from '@components/PopupGuide.vue';
import Header from '@components/Header.vue';
import Footer from '@components/Footer.vue';

export default {
  name: 'mypage',
  head: {
    title: {
      inner: 'My Page',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'My Page Of Smart Solution',
      },
    ],
  },
  components: {
    PopupGuide,
    Footer,
    Header,
  },
  data() {
    return {
      loaded: false,
      userTelno: '',
      pw: '',
      pw_change: '',
      pw_confirm: '',
      profilePhoto: '',
      franchiseProfilePhoto: '',
      searched_fc_id: '',
      deviceInfoSelected: {},
      selectedPhoto: null,
      isDisableChangePW: true,
      isChangeProfilePhoto: false,
      isGuidePopupOpened: false,
      isFranchise: false,
      isAccess: true,
      isShowFranchInfo: false,
    };
  },
  computed: {
    ...mapGetters([
      'fetchedUserProfile',
      'fetchedUserSummary',
      'fetchedUserProfileImage',
      'fetchedFranchiseProfileImage',
      'fetchedDeviceTotalCnt',
      'fcNameResult',
      'getUserDevices',
    ]),
  },
  async created() {
    try {
      if (!sessionStorage.getItem('user_info')) {
        window.location.href = `${window.location.origin}/auth/login`;
        this.isAccess = false;
      } else {
        this.isAccess = true;
      }

      const userInfo = JSON.parse(sessionStorage.getItem('user_info'));
      const roleCode = sessionStorage.getItem('role_code');
      const [profilePhoto] = await Promise.allSettled([
        import('@assets/images/image-profile.png'),
        this.$store.dispatch('FETCH_USER_SUMMARY'),
        this.$store.dispatch('FETCH_USER_PROFILE', userInfo.user.user_id),
      ]);
      const { total_count: totalCnt } = this.fetchedUserSummary.device;
      const {
        profile_pic_exist: useUserProfile,
        franchise_profile_pic_exist: useFranchiseProfile,
        user_telno: userTel,
      } = this.fetchedUserProfile;
      const isUserProfile = useUserProfile === 'Y';
      const isFranchiseProfile =
        useFranchiseProfile === 'Y' &&
        roleCode === Common.FranchiseBranchOffice;
      this.profilePhoto = profilePhoto.value.default;
      this.franchiseProfilePhoto = profilePhoto.value.default;
      this.userTelno = userTel;

      await Promise.allSettled([
        totalCnt && this.$store.dispatch('FETCH_USER_DEVICES'),
        isUserProfile && this.FETCH_USER_PROFILE_IMAGE(),
        isFranchiseProfile && this.FETCH_FRANCHISE_PROFILE_IMAGE(),
      ]);

      if (totalCnt) {
        this.deviceInfoSelected = _.find(
          this.getUserDevices,
          (device) => device.user_role_code !== '12006',
        );
        this.$store.dispatch('SAVE_SELECTED_DEVICE', this.deviceInfoSelected);
        videoData.data.product_type_id =
          this.deviceInfoSelected.product_type_id;
        this.isShowFranchInfo = true;
      }

      if (isUserProfile) {
        this.profilePhoto = this.fetchedUserProfileImage;
      }

      if (isFranchiseProfile) {
        this.franchiseProfilePhoto = this.fetchedFranchiseProfileImage;
      }

      this.loaded = true;
    } catch (err) {
      exceptHandler(err);
    }
  },
  methods: {
    ...mapActions([
      'FETCH_USER_PROFILE_IMAGE',
      'FETCH_FRANCHISE_PROFILE_IMAGE',
    ]),
    toggleButton() {
      if (this.searched_fc_id) this.searched_fc_id = '';
    },
    changeCheckPW() {
      this.isDisableChangePW = false;

      if (!this.pw.length) {
        this.isDisableChangePW = true;
      }
    },
    convertArrayBufferToBase64(data) {
      const bytes = new Uint8Array(data);
      let binary = '';

      for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }

      return window.btoa(binary);
    },
    async clickDeletePhotoFile() {
      const isConfirm = confirm(eve.Lang.t('profile.delete_profil'));
      if (!isConfirm) return;

      const profilePhoto = await import('@assets/images/image-profile.png');
      this.profilePhoto = profilePhoto.default;
      await this.$store.dispatch('DELETE_PROFILE_PHOTO');
    },
    clickPhotoFile() {
      $('input:file').click();
      this.isChangeProfilePhoto = true;
    },
    changeProfile(e) {
      const files = e.target.files[0];
      this.profilePhoto = URL.createObjectURL(files);
      this.selectedPhoto = files;
    },
    telno(e) {
      this.userTelno = e.target.value;
    },
    async editUserProfile() {
      // 비밀번호 정규식, 영문 대소문자, 숫자, 특수문자 1자 이상ㄴ 포함하여 6~16자 입력
      const passRule =
        /^.*(?=^.{6,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).*$/;

      if (
        this.isDisableChangePW === false &&
        (this.pw_change.length === 0 ||
          this.pw_confirm.length === 0 ||
          this.pw.length === 0)
      ) {
        alert(eve.Lang.t('common.d_pw_input'));
        return;
      }

      if (this.isDisableChangePW === false && !passRule.test(this.pw_change)) {
        alert(
          eve.Lang.t('common.d_pw_type_check', {
            cnt_range: '6~16',
          }),
        );
        return;
      }

      if (
        this.isDisableChangePW === false &&
        this.pw_change !== this.pw_confirm
      ) {
        alert(eve.Lang.t('common.d_pw_wrong_confirm'));
        return;
      }

      await this.$store.dispatch('EDIT_USER_PROFILE', {
        telno: this.userTelno,
        pw: this.pw,
        pw_confirm: this.pw_confirm,
        isDisableChangePW: this.isDisableChangePW,
        isChangeProfilePhoto: this.isChangeProfilePhoto,
        selectedPhoto: this.selectedPhoto,
      });
      this.isDisableChangePW = true;
      this.isChangeProfilePhoto = false;
    },
    async searchFCName(e) {
      this.searched_fc_id = '';
      const franchiseName = e.target.value;
      await this.$store.dispatch('SEARCH_FC_NAME', _.trim(franchiseName));
    },
    async requestJoinFC() {
      const checkId = _.find(
        this.fcNameResult,
        (list) => list.id === this.searched_fc_id,
      );
      if (!this.searched_fc_id || !checkId) {
        alert(eve.Lang.t('mov_making.msg_not_exist_select'));
        return;
      }
      const isChanged = confirm(
        eve.Lang.t('common.desc_change_franchsise_sign_off'),
      );
      if (isChanged) {
        const { data } = await this.$store.dispatch(
          'REQUEST_JOIN_FC',
          this.searched_fc_id,
        );
        if (data.code === Common.CODE_OK) {
          alert(eve.Lang.t('common.t_msg_complete'));
          window.location.reload();
        } else if (data.code === ERR.PRODUCT_TYPE_ID_CANNOTBE_REGISTERED) {
          alert(
            eve.Lang.t('common.desc_not_supported_sign', {
              limit_action: eve.Lang.t('common.cannot_join_franchise'),
            }),
          );
        }
      }
    },
    onGuidePopup() {
      this.isGuidePopupOpened = !this.isGuidePopupOpened;
    },
    makeDateForm(date) {
      return moment(date).format('YYYY.MM.DD HH:MM');
    },
  },
};
</script>

<style scoped lang="scss">
.mypage {
  padding-top: 58px;
  background-color: $gray-f1;
}

.breadcrumb {
  width: 100%;
  margin: 48px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    font-size: 24px;
  }
}

div.row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  height: 500px;
  padding: 16px 24px 0 24px;
  background-color: $white;
  position: relative;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

  .header {
    width: 100%;
    padding-bottom: 12px;
    border-bottom: 1px solid $gray-eb;
    color: $gray-33;
    font-size: 14px;
    font-weight: bold;
  }

  .body {
    width: 100%;
    padding-top: 20px;
    background-color: $white;
  }

  .footer {
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .button {
      width: auto;
      height: 36px;
      padding: 0 20px;
      -webkit-border-radius: 18px;
      -moz-border-radius: 18px;
      border-radius: 18px;
    }
  }
}

.form-box {
  display: flex;
  align-items: center;
  height: 30px;

  label {
    width: 40%;
    font-size: 12px;
    color: $gray-99;
  }

  p,
  input {
    width: 65%;
  }

  p {
    font-size: 12px;
    color: $gray-66;
    word-break: break-all;
  }

  input {
    height: 30px;
  }
}

.profile,
.franchise {
  width: 100%;
  .info {
    width: 100%;
    display: flex;
    align-items: center;

    .image {
      position: relative;

      .image-box {
        width: 96px;
        height: 96px;
        border: 1px solid #e3e3e3;
        -webkit-border-radius: 55px;
        -moz-border-radius: 55px;
        border-radius: 55px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          min-width: 100%;
          min-height: 100%;
          object-fit: cover;
        }
      }

      button.icon {
        width: 36px;
        height: 36px;
        position: absolute;
        bottom: -10px;
        background-color: $white;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        border-radius: 18px;

        &.delete {
          left: 0;
          background-image: url(~@assets/images/icon-delete.png);

          &:hover {
            background-image: url(~@assets/images/icon-delete-on.png);
          }
        }

        &.change {
          right: 0;
          background-image: url(~@assets/images/icon-change.png);

          &:hover {
            background-image: url(~@assets/images/icon-change-on.png);
          }
        }
      }
    }

    .spec {
      /* width: calc(100% - 150px); */
      width: 100%;
      margin-left: 12px;

      .form-box {
        p {
          padding-left: 12px;
        }
      }

      .form-box + .form-box {
        margin-top: 12px;
      }
    }
  }

  .password {
    width: 100%;
    margin-top: 18px;

    .form-box {
      p {
        padding-left: 12px;
      }
    }

    .form-box + .form-box {
      margin-top: 12px;
    }
  }

  .search {
    .description {
      margin-top: 10px;
      font-size: 11px;
      font-weight: bold;
      color: $gray-66;
      line-height: 1.8em;
    }

    .search-box {
      width: 100%;
      height: 36px;
      margin-top: 12px;
      padding-left: 36px;
      border: 1px solid $gray-e6;
      position: relative;
      background-image: url(~@assets/images/icon-search.png);
      background-repeat: no-repeat;
      background-position: center left 12px;
      background-size: 12px;

      & > input {
        width: 100%;
        height: 100%;
        border: none;
        padding: 0;
      }
    }
    .result-box {
      width: 100%;
      border-right: 1px solid $gray-e6;
      border-bottom: 1px solid $gray-e6;
      border-left: 1px solid $gray-e6;
      overflow-y: scroll;

      &.req-join {
        max-height: 250px;
      }
      &.joined {
        max-height: 150px;
      }

      ul {
        width: 100%;
        flex-direction: column;
        background-color: $white;

        li {
          width: 100%;
          height: 36px;
          padding: 12px;

          .checkbox {
            span {
              color: $primary;
              font-weight: bold;
              font-size: 12px;

              span {
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
